const tr = {
  '赞助和游戏责任': 'Sponsorluk ve Oyun Sorumluluğu',
'产品': 'Ürünler',
'游戏': 'Oyunlar',
"announcement": 'Heyecan dolu bir deneyime dalın ve çevrimiçi oyunlarımızın heyecanını bugün yaşayın! Eğlencenin ve ödüllerin köşede olduğu bir fırsatlar dünyasını keşfedin!',
'排名': 'Sıralama',
"更多的": "Daha Fazla",
"拱廊": "Oyun Salonu",
"撞车游戏": "Çarpışma Oyunları",
"钓鱼游戏": "Balık Oyunları",
"直播": "Canlı",
"登录": "Giriş Yap",
"注册": 'Kayıt Ol',
"选择语言": 'Dil',
"介绍人": "Tanıtıcı",
"账号": "Hesap",
"密码": "Şifre",
"确认密码": "Şifreyi Onayla",
"真实姓名": "Gerçek İsim",
"手机号码": "Telefon Numarası",
"取款密码": "Para Çekme Şifresi",
"验证码": "Kod",
"请输入密码": "Lütfen şifreyi girin",
"请输入验证码": "Lütfen doğrulama kodunu girin",
"请输入账号": "Lütfen bir hesap girin",
"请重新获取验证码": "Lütfen doğrulama kodunu tekrar alın",
"正在登录中": "Giriş yapılıyor",
"网络异常,请稍后再试": "Ağ hatası, lütfen daha sonra tekrar deneyin",
"账号名": "Hesap Adı",
"余额": "Bakiye",
"会员中心": "Üye",
"网上存款": "Çevrimiçi Para Yatırma",
"网上提款": "Çevrimiçi Para Çekme",
"退出": "Çıkış",
"请再次输入密码": "Lütfen şifreyi tekrar girin",
"请输入姓名": "Lütfen adınızı girin",
"请输入手机号": "Lütfen telefon numaranızı girin",
"请输入取款密码": "Lütfen para çekme şifresini girin",
"正在注册中": "Kayıt Olunuyor",
"确定": "Belirle",
"注册成功": "Giriş başarılı",
"热门优惠": "Popüler İndirimler",
"首页": "Anasayfa",
"查看活动": "Etkinlikleri Görüntüle",
"正在获取活动列表": "Etkinlik listesi alınıyor",
"暂无活动": "Şu anda etkinlik yok",
"活动详情": "Etkinlik Detayları",
"视讯直播": "Video Canlı Yayın",
"直播类型": "Canlı Yayın Türü",
"热门": "Popüler",
"推荐": "Tavsiye Et",
"最新": "Güncel",
"全部": "Hepsi",
"获取类型中": "Tür alınıyor",
"获取具体信息中": "Belirli bilgiler alınıyor",
"开始": "Başla",
"正在获取资源": "Kaynaklar alınıyor",
"正在努力加载中": "Yüklenmeye çalışılıyor",
"电子": "Elektron",
"大厅": "Salon",
"游戏类型": "Oyun Türü",
"游戏标签": "Oyun Etiketleri",
"错误的类型": "Yanlış Tür",
"返回首页": "Anasayfaya Dön",
"正在获取游戏列表": "Oyun listesi alınıyor",
"暂无游戏": "Şu anda mevcut oyun yok",
"当前未登录,请先登录": "Şu anda giriş yapılmamış, lütfen önce giriş yapın",
"联系我们": "Bizimle İletişime Geçin",
"导航": "Navigasyon",
"配置文件信息": "Profil Bilgileri",
"常用功能": "Ortak İşlevler",
"充值": "Yükle",
"提现": "Para Çek",
"功能列表": "Fonksiyonlar",
"交易": "İşlem",
"设置": "Ayarla",
"修改登入密码": "Giriş Şifresini Değiştir",
"修改提现密码": "Para Çekme Şifresini Değiştir",
"银行卡": "Banka Kartı",
"若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "Eğer daha önce telefon numaranız veya sosyal medya platformu ile siteye giriş yaptıysanız, lütfen müşteri hizmetleri ile doğrudan iletişime geçerek yardım isteyin",
"旧密码": "Eski Şifre",
"请输入旧密码": "Lütfen eski şifrenizi girin",
"设定新密码": "Yeni Şifre Belirle",
"确认新密码": "Yeni Şifreyi Onayla",
"确认": "Onayla",
"下一步": "Sonraki Adım",
"交易功能": "İşlem Fonksiyonları",
"支付方式": "Ödeme Yöntemi",
"充值教学": "Yükleme Eğitimi",
"选择渠道": "Bir Kanal Seçin",
"存款金额": "Para Yatırma",
"实际金额": "Gerçek Miktar",
"提现币种": "Para Çekme Para Birimi",
"提现银行卡": "Para Çekme Banka Kartı",
"新增": "Yeni Eklendi",
"提现金额": "Para Çekme Miktarı",
"提现金额范围": "Para Çekme Miktarı Aralığı",
"请输入金额": "Lütfen miktarı girin",
"实际到帐": "Gerçek Alım",
"一般手续费": "Genel İşlem Ücretleri",
  "强制手续费": "Zorunlu işlem ücretleri",
"上一步": "Geri",
"修改成功": "Başarıyla değiştirildi",
"修改中": "Değiştiriliyor",
"拼命加载中": "Aşırı yükleniyor",
"编辑登录密码": "Giriş şifresini düzenle",
"编辑提款密码": "Çekim şifresini düzenle",
"如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "Eğer web sitesine telefon numarası veya sosyal medya platformu ile giriş yaptıysanız, lütfen yardım için müşteri hizmetleri ile iletişime geçin.",
"请输入新密码": "Lütfen yeni şifreyi girin",
"新密码不能和旧密码一致": "Yeni şifre eski şifreyle aynı olamaz",
"两次输入密码不一致!": "İki şifre girişi birbirine uymuyor!",
"请输入提款密码": "Lütfen çekim şifresini girin",
"输入提款密码": "Çekim şifresini girin",
"请设置新的提款密码": "Lütfen yeni bir çekim şifresi ayarlayın",
"设置6位提款密码，并记住您的密码": "6 haneli çekim şifresi ayarlayın ve şifrenizi hatırlayın",
"请输入新的提款密码": "Lütfen yeni çekim şifresini girin",
"存款": "Yatırma",
"取款": "Çekme",
"付款方式": "Ödeme Yöntemi",
"存款金额": "Yatırım Tutarı",
"请输入金额": "Lütfen tutarı girin",
"下一步": "Sonraki adım",
"提款金额": "Çekim Tutarı",
"提款银行卡": "Çekim Banka Kartı",
"请输入您的银行卡号": "Lütfen banka kartı numaranızı girin",
"切换语言将会刷新页面": "Dil değişikliği sayfayı yenileyecektir",
"充值方式": "Yükleme yöntemi",
"取消": "İptal",
"登录过期,是否重新登录": "Giriş süresi doldu, tekrar giriş yapmak istiyor musunuz?",
"系统提示": "Sistem bildirimi",
"国家": "Ülke",
"请输入": "Lütfen girin",
"请选择": "Lütfen seçin",
"please-select-method": "Lütfen ödeme yöntemini seçin",

//新的一套
"加载更多": "Daha fazla yükle",
"开始": "Oyna",
// "存取款":"Deposit/Withdrawal",
"存取款": "Yatırma",
"加钱": "Para ekle",
"选择您的奖金": "Bonusunuzu seçin",
"100%,最高1500": "100% maksimum 1.500 R$",
"CASINO": "KASİNO",
"Select your lottery": "Şans oyununu seçin",
"don't want a lottery": "şans oyunu istemiyorum",
"金额不得小于": "Tutar en az şu kadar olmalıdır",
"金额不得大于": "Tutar en fazla şu kadar olmalıdır",
"加载失败": "Yükleme başarısız",
"活动中心": "Etkinlik Merkezi",
"**财富攀升-BRL的充值促销**": "**Zenginlik Tırmanışı - BRL Yenileme Promosyonu**",
"在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "Bu benzersiz etkinlikte, size zenginlik biriktirmek için sonsuz bir fırsat sunuyoruz. İster yeni başlayan, ister deneyimli bir kullanıcı olun, her yükleme size farklı seviyelerde hediyeler ve daha yüksek seviyelerde ayrıcalıklar getirecek.",
"**青铜级别（青铜）**": "**Bronz Seviye (Bronz)**",
"-重新加载的总金额：1.000-5.000 BRL": "- Yenilenen toplam tutar: 1.000 - 5.000 BRL",
"-礼品的比例从5%逐渐增加到10%": "- Hediyelerin oranı %5'ten %10'a kadar kademeli olarak artar",
"-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "- İlk yüklemede, size özel bir hediye alacaksınız. Zenginliğe giden kapı açıktır. Her ek yüklemede daha fazla hediye alacaksınız.",
"**银级（银级）**": "**Gümüş Seviye (Gümüş)**",
"-重新加载的总金额：5.001-15.000 BRL": "- Yenilenen toplam tutar: 5.001 - 15.000 BRL",
"-礼品的比例从10%逐渐增加到15%": "- Hediyelerin oranı %10'dan %15'e kadar kademeli olarak artar",
"-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "- Gümüş seviyeye ulaştınız, zenginliğiniz artmaya devam ediyor. Ne kadar çok yükleme yaparsanız, hediyelerin oranı o kadar yüksek olur. Daha fazla yükleyin, daha fazla kazanın!",
"**黄金级别（Gold）**": "**Altın Seviye (Altın)**",
"-重新加载的总金额：15.001-30.000 BRL": "- Yenilenen toplam tutar: 15.001 - 30.000 BRL",
"-礼品的比例从15%逐渐增加到18%": "- Hediyelerin oranı %15'ten %18'e kadar kademeli olarak artar",
"-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "- Zenginlik yolunda ilerliyorsunuz. Altın üye olduğunuzda daha cömert hediyeler alacaksınız. Zenginliğinizin büyümesi kaçınılmaz.",
"**白金级别（白金）**": "**Platin Seviye (Platin)**",
"-随着冷却值的增加，会奖励更多的礼物": "- Soğuma değeri arttıkça daha fazla hediye verilecektir",
"-重新加载的总金额：30.001-60.000 BRL": "- Yenilenen toplam tutar: 30.001 - 60.000 BRL",
"-礼品的比例从18%逐渐增加到20%": "- Hediyelerin oranı %18'den %20'ye kadar kademeli olarak artar",
"-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "- Platin seviyede, yüklemeleriniz daha yüksek oranlarda hediyeler alacaktır. Mali yönetiminiz daha da mükemmel hale gelecek ve büyük kazançlar elde edeceksiniz.",
"**钻石级别（钻石）**": "**Elmas Seviye (Elmas)**",
"-重新加载的总金额：60.001-100.000 BRL": "- Yenilenen toplam tutar: 60.001 - 100.000 BRL",
"-礼品比例最高，达到20%": "- Hediyelerin oranı en yüksektir, %20'ye kadar ulaşır",
"-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "- Bu, onurun zirvesidir, son seçimdir. Elmas üye olduğunuzda, en yüksek oranlarda hediyelerin tadını çıkaracak, zenginliğinizin hızla büyümesini sağlayacaksınız ve mali hayallerinizin gerçekleşmesine çok az kaldı.",
"不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": "Bu eşsiz fırsatı kaçırmayın. Zenginlik merdivenini tırmanın, zenginliğinizin katlanarak arttığını izleyin. BRL Yenileme Promosyonu'na katılın ve mali hedeflerinize ulaşmak için en iyi desteği sağlamayı garanti edin. Zenginlik yolculuğu sizinle başlar, kazançlar durmaksızın artar, başarı yanınızdadır!",
"游戏记录": "Oyun Kaydı",
  "交易记录": "İşlem kayıtları",
  "提交": "Gönder",
  "游戏品牌": "Oyun markası",
  "游戏名称": "Oyun adı",
  "下注时间": "Bahis zamanı",
  "下注金额": "Bahis miktarı",
  "输赢金额": "Kazanılan veya kaybedilen miktar",
  "上一页": "Önceki sayfa",
  "下一页": "Sonraki sayfa",
  "申请时间": "Başvuru zamanı",
  "状态": "Durum",
  "法规与合作伙伴": "Regülasyonlar ve Ortaklar",
  "为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。": "Bu web sitesine kaydolmak için kullanıcıların genel şartlar ve koşulları kabul etmesi gerekmektedir. Şartlar ve koşullar güncellendiğinde, mevcut kullanıcılar belirtilen güncelleme yürürlüğe girmeden önce ürün ve hizmetleri kullanmayı durdurmayı seçebilirler, yani güncellemenin duyurulmasından en az iki hafta sonra.",
  '您可以使用用户名和密码登录': 'Kullanıcı adı ve şifre ile giriş yapabilirsiniz',
  '创建账户': 'Hesap oluştur',
  '银行信息': 'Banka bilgileri',
  '名称': 'Ad',
  '时间': 'Zaman',
  '最小': 'Min',
  '最大': 'Max',
  '即时到账': 'Anında ödeme',
  '选择银行': 'Banka seçin',
  '银行账号': 'Banka hesap numarası',
  '请输入银行账号': 'Lütfen banka hesap numaranızı girin',
  '金额': 'Miktar',
  '支出': 'Ödeme',
  '输入金额': 'Lütfen miktarı girin',
  "暂无数据": "Şu anda mevcut veri yok",
  '获奖人': 'Kazanan',
  '游戏榜': 'Oyun Sıralaması',
  '新游戏榜': 'Yeni Oyun Sıralaması',
  '热门游戏榜': 'Popüler Oyun Sıralaması',
  '电子游戏': 'Elektronik Oyunlar',
  '主要余额': 'Ana bakiye',
  '历史记录': 'Geçmiş',
  '付款名称': 'Ödeme adı',
  '费用': 'Maliyet',
  '免费': 'Ücretsiz',
  '立即生效': 'Hemen geçerli',
  '银行选择': 'Banka seçimi',
  '银行账户': 'Banka hesabı',
  '充值金额': 'Yükleme miktarı',
  '收款名称': 'Ödeme adı',
  '账号类型': 'Hesap türü',
  '收账账号': 'Tahsilat hesap numarası',
  'CPF号码': 'CPF numarası',
  '提现密码': 'Para çekme şifresi',
  '请输入名称': 'Lütfen bir isim girin',
  '请选择类型': 'Lütfen türü seçin',
  '请输入CPF': 'Lütfen CPF girin',
  '请输入提现金额': 'Lütfen para çekme miktarını girin',
  '请输入正确的参数': 'Lütfen doğru parametreleri girin',
  "收藏夹": "Favoriler",
  "敬请期待": "Çok Yakında",
  "用户": "Kullanıcı",
  "玩家": "Oyuncu",
  "时间": "Zaman",
  "赌场": "Kumarhane",
  "体育运动": "Sporlar",
  "促销": "Promosyon",
  "支持/法律": "Destek/Hukuk",
  "加入我们的社区": "Topluluğumuza katılın",
  "赌场主页": "Kumarhane Anasayfası",
  "插槽": "Makaralar",
  "现场赌场": "Canlı Kumarhane",
  "新版本": "Yeni Sürümler",
  "桌面游戏": "Masa Oyunları",
  "体育之家": "Spor Evi",
  "会员俱乐部": "VIP Kulübü",
  "优惠促销": "Promosyonlar",
  "赌博意识": "Kumar Bilinci",
  "常问问题": "Sıkça Sorulan Sorular",
  "条款和条件": "Şartlar ve Koşullar",
  "隐私政策": "Gizlilik Politikası",
  "赞助和游戏责任": "Sponsorlik ve Oyun Sorumlulukları",
  "页脚文本": "BetBlitz, çevrimiçi oyun ve bahis alanında küresel bir hakimiyet sağlamayı hedeflemektedir ve müşteri memnuniyetini öncelikli hale getirmektedir. Faaliyetlerimizin merkezinde güven, bütünlük ve adalet ilkeleri yer almakta olup, bu ilkeler her türlü girişimimizi yönlendirmektedir.",
  "充电时间": "Yükleme Süresi",
  "订单号": "Sipariş Numarası",
  "充值金额": "Yükleme Miktarı",
  "充值方式": "Yükleme Yöntemi",
  "地位": "Durum",

  '负责任的博彩': 'Sorumlu Kumar',
  '快速链接': 'Hızlı Bağlantılar',
  '桌上游戏': 'Masa Oyunları',
  '二十一点': 'Blackjack',
  '扑克': 'Poker',
  '百家乐': 'Baccarat',
  '掷骰子': 'Küçük Zarlama',
  '奖金': 'Bonuslar',
  '赌场奖金': 'Kumarhane Bonusu',
  '自由旋转': 'Ücretsiz Dönüş',
  '免费投注': 'Ücretsiz Bahisler',
  '信息': 'Bilgi',
  "": "",

  "老虎机游戏": "Makaralı Oyunlar",
  "赌场游戏": "Kumarhane Oyunları",
  "更多游戏": "Daha Fazla Oyun",
  "搜索游戏": "Oyun Ara",
  "特色提供商": "Öne Çıkan Sağlayıcılar",
  "Logout": "Çıkış Yap",
  "Personal Center": "Kişisel Merkez",
  "Limit": "Limit",
  "MessageCenter": "Mesaj Merkezi",

  'All': 'Hepsi',
  'Arcade': 'Oyun Salonu',
  'Bingo': 'Bingo',
  'Card': 'Kart',
  'Casino': 'Kumarhane',
  'Crash': 'Çarpışma',
  'Fish': 'Balık',
  'Live': 'Canlı',
  'Lottery': 'Piyango',
  'Slot': 'Makaralar',
  'Sports': 'Spor',
  'Video Game': 'Video Oyunu',

  'cs-title': '7x24 SAAT',
  'cs-text': 'Müşteri hizmetleri sorun giderme ve sorular için mevcuttur.',
  'cs-contact': 'İletişim',

  'social-media': 'Sosyal Medya',
  'contact-us': 'Aşağıdaki yollarla bizimle iletişime geçin',

  'footer-line1': 'tarafından işletilmektedir',
  'footer-line2': 'Şirketin kayıtlı adresi',
  'footer-line3': 'Bu ürün yalnızca 18 yaş üstü kullanıcılar içindir ve eğlence amaçlıdır',
  'footer-line4': 'Bu oyun uygulama içi satın alımlar içermektedir',
  'footer-line5': 'Bir oyuncunun sosyal kumar oynaması veya kazanması, gelecekte gerçek para ile kumar ve ilgili oyunlarda kazanacağı anlamına gelmez',

  // Added Lines

  'popup-message': 'Hatırlatmaları kapatmak ister misiniz?',

  'sign-in': 'Giriş Yap',
  'password': 'Şifre',
  'confirm-password': 'Şifreyi Onayla',
  'remember-me': 'Beni Hatırla',
  'forgot-password': 'Şifremi Unuttum',
  "sign-in-note": "Hesabınız yok mu?",
  "register-note": "Hesabınız var mı?",
  "register": "Kayıt Ol",

  "popular": "Popüler",
  "promotion": "Promosyon",
  "follow": "Takip Et",
  'search': 'Ara',

  'home': 'Anasayfa',
  'deposit': 'Yatır',
  'withdraw': 'Çek',
  'profile': 'Profil',
  'online-cs': 'Çevrimiçi Müşteri Hizmetleri',

  "search-games": "Oyun Ara",
  "search-results": "Arama Sonuçları",

  'Activity': 'Etkinlik',
  'Rebates': 'İadeler',
  'VIP': 'VIP',
  'History': 'Geçmiş',
  'Cover': 'Kapat',

  'recharge-activity': 'Yükleme Etkinliği',
  'time': 'Zaman',
  'reward': 'Ödül',
  'deposit-value': 'Yatırım Değeri',
  'status': 'Durum',
  'reward-bonus-discription': "İlk 100 R$ yatırdığınızda 10 R$ bedava alın.",
  'invitaion-activity-discription': "Arkadaş davet edin ve 100 R$ bedava kazanın.",
  'daily-loss-activity-discription': "Günlük %8 İade",
  'recharge-rebet-activity-discription': "Tek bir işlemde 100 R$ yükleme yaptığınızda 20% iade alın.",
  'user-not-eligible': "Bu ödül için uygun değilsiniz",
  '不符合领取资格': "Almak için uygun değil",
  'reward-claimed': "Ödül başarıyla alındı!",
  '没有符合资格的充值': 'Uygun yükleme yok',

  'invitation-activity': 'Davet Etkinliği',
  'recharge-amount': 'Yükleme Miktarı',
  'spin': 'Dön',
  'bonus': 'Bonus',
  'invites': 'Davetler',
  "install-btn": "KUR",

  'daily-loss-relief-fund': 'Günlük Kayıp Yardım Fonu',
  'percent': 'Yüzde',
  "amount-loss": "Kayıp Miktarı",

  'recharge-rebate-activity': 'Yükleme İade<br>Etkinliği',
  'recharge-amount': 'Yükleme Miktarı',
  'return-ratio': 'İade oranı',
  'return-amount': 'İade Miktarı',

  'recharge-note1': 'Tek bir 100 Brezilya reali yüklemesi etkinliğe katılabilir',
  'recharge-note2': 'Her 100 Brezilya reali veya daha fazla yükleme bağımsız olarak hesaplanır;',
  'recharge-note3': 'Bu etkinlik, ödül almak için yükleme miktarının en az 5 katını gerektirir;',
  'recharge-note4': 'Standartları karşılamayan veya etkinlikten sonra ödül toplama işlemini tamamlamayanlar, ödülü bir daha alamayacaktır;',
  'recharge-note5': 'Kaybı önlemek için, lütfen görevleri önceden tamamlayın veya ödül alın;',
  'recharge-note6': 'Bu etkinlik, hesap sahiplerinin normal işlem davranışı ile sınırlıdır ve kiralama, hile, bot kullanımı, farklı hesaplarla oyun oynama, karşılıklı kazanma, tahkim, arayüzler, protokoller, zafiyetleri istismar etme ve grup kontrolü gibi teknik yöntemlere yasaklanır. Aksi takdirde, ödüller iptal edilecek, düşürülecek, dondurulacak veya hatta kara listeye alınacaktır;',
  'recharge-note7': 'Tüm etkinliklerin yorumlama hakları nihai olarak bu platforma aittir;',

  'claim': 'Talep Et',

  'lottery-wheel': 'Piyango Çarkı',
  'number-of-spin': 'Dönme Sayısı',
  'spin': 'Dön',

  'upgrade-required': 'Yükseltme gerekli',
  'recharge': 'Yükle',
  'betting': 'Bahis',
  'Bonus': 'Bonus',
  'Notification': 'Bildirim',
  'Announcement': 'Duyuru',
  'Support': 'Destek',
  'level': 'Seviye',

  'view-data': 'Verileri Görüntüle',
  'current-data': 'Mevcut Veriler',
  'last': 'Son',
  'days': 'gün',
  'event': 'Etkinlik',
  'notes': 'Notlar',

  'rebate-funds': 'İade Fonları',
  'statement': 'Beyan',
  'rebate': 'İade',

  'platform-rebate': 'Platform İadesi',
  'action': 'Eylem',
  'type': 'Tür',
  'amount': 'Miktar',

  'record': 'Kayıt',
  'recharge-method': 'Yükleme Yöntemi',
  'recharge-note': 'Herhangi bir sorunla karşılaşırsanız lütfen bizimle iletişime geçin!',
  'withdrawal-note': 'Herhangi bir sorunla karşılaşırsanız lütfen bizimle iletişime geçin!',
  'online-service': 'Çevrimiçi Hizmet',
  'recharge-amount': 'Yükleme Miktarı',
  'withdrawal': 'Çekim',
  'online-withdrawal': 'Çevrimiçi Çekim',
  'withdrawal-method': 'Çekim Yöntemi',
  'fee': 'Ücret',
  'full-name': 'Tam Ad',
  'please-enter-your': 'Lütfen giriniz',
  'name': 'İsim',
  'collection-account-number': 'Tahsilat Hesap Numarası',
  'withdraw-password': 'Çekim Şifresi',
  'phone-number': 'Telefon Numarası',
  'security-center': 'Güvenlik Merkezi',
  'change-password': 'Şifre Değiştir',
  'financial-status': 'Finansal Durum',
  'verify-password': 'Şifreyi Doğrula',
  'bind-email-note': 'E-postanızı bağlıyorsunuz ve giriş şifrenizi doğrulamanız gerekiyor',
  'bind-password-note': 'Şifrenizi değiştiriyorsunuz ve şifre doğrulaması için giriş yapmanız gerekiyor',
  'next-step': 'Sonraki Adım',

  'balance': 'Bakiye',
  'information-center': 'Bilgi Merkezi',
  'order-center': 'Sipariş Merkezi',
  'agency-center': 'Acenta Merkezi',
  'exit': 'Çıkış',
  'bonus-amount': 'Bonus Miktarı',
  'fee-amount': 'Ücret Miktarı',
  'change': 'Değiştir',
  'male': 'Erkek',
  'female': 'Kadın',
  'submit': 'Gönder',
  'information': 'Bilgi',
  'Details': 'Detaylar',
  'Fee': 'Ücret',
  'Association': 'Dernek',

  'Invite': 'Davet Et',
  'Agent': 'Ajan',
  'Invitation record': 'Davet Kaydı',
  'Invitation': 'Davet',
  'Reward': 'Ödül',
  'Agency mechanism': 'Acenta Mekanizması',
  'Register subordinates': 'Alt çalışanları kaydet',
  'my-id': 'Benim ID',
  'inviter-id': 'Davet eden ID',
  'ordinary-agent': 'Sıradan Ajan',
  'my-invitation-information': 'Davet bilgilerim',
  'my-links': 'Bağlantılarım',
  'save-qr-code': 'QR kodunu kaydet',
  'my-invitation-record': 'Davet kaydım',
  'total-number-of-invited-people': 'Toplam davet edilen kişi sayısı',
  'direct-reports': 'Doğrudan Raporlar',
  'invitation-rewards': 'Davet ödülleri',
  'invitation-total-reward': 'Davet toplam ödülü',
  'directly-invite-rewards': 'Doğrudan davet ödülleri',
  'indirect-invitation-reward': 'Dolaylı davet ödülü',
  'more': 'Daha Fazla',

  'invitation-total': 'Davet toplamı',
  'direct-rewards': 'Doğrudan ödüller',
  'indirect-incentives': 'Dolaylı teşvikler',
  'no-agent': 'Gösterilecek ajans yok',
  "no-record": "Kayıt bulunamadı",
  "no-more-roll": "Dönüş kalmadı",
  'rebate-ration': 'İade oranı',
  'deposit-value': 'Yatırım değeri',

  'bet-on': 'Bahis yap',
  'settlement': 'Ödeme',
  'consumption': 'Tüketim',
  'agent-text': 'Ajan Metni',
  'reg-sub-text': "Kayıt işlemini tamamladıktan sonra, davetlinin kayıtlı telefon numarasını, davet kodunu ve UID'sini girerek bağlayın.",
  'your-invitation-code': 'Davet kodunuz',
  'UID-of-the-invitee': 'Davetlinin UID\'si',
  'user-does-not-exist': 'KULLANICI MEVCUT DEĞİL',

  'no-record': 'Kayıt bulunamadı',
  'reg-success': 'Kaydınız başarıyla tamamlandı',
  'reg-failed': 'Kayıt Başarısız',
  'valid-number': 'Lütfen geçerli bir cep telefonu numarası girin',
  'valid-pass2': 'Şifreler eşleşmiyor',
  'pass-error': 'Şifre en az 6 karakter olmalıdır',
  "network-error": "Ağ hatası, lütfen daha sonra tekrar deneyin",
  'fix-error': 'Lütfen formdaki hatayı düzeltin',

  'invalid_phone': 'Lütfen doğru cep telefonu numarasını girin.'
}
export default tr



// WEBPACK FOOTER //
// ./src/utils/lang/config/tr.js